/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InputsDinamicos from 'src/components/InputsDinamicos';
import UniqueKeyV4 from 'src/components/InputsDinamicos/UniqueKeyV4';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import usePaginaCompra from 'src/reducers/PaginaCompra/usePaginaCompra';
import { guardarLead } from 'src/services';
import { urlSetBeneficiarios } from 'src/services/urls';
import { scrollTop } from 'src/utils/functiones';
import uuid from 'uuid';
import CheckBeneficiarioIgualTitular from './CheckBeneficiarioIgualTitular';
import EditarVigencia from './EditarVigencia';
import useQueryString from 'src/hooks/useQueryString';
import './styles.css';
import useCustomToast from 'src/hooks/useCustomToast';

const PaginaCompraPage = () => {
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    shouldUnregister: false,
  });
  const [disabledButton, setDisabledButton] = useState(false);
  const { cotizacion, idCotizacion } = useCotizacion();
  const { execEvent, isLoadingCallbacks } = usePageValidation('paginaCompra');
  const { reset } = methods;
  const { setShowForm, editarBeneficiario, indexEditar } = usePaginaCompra();
  const { addWarningToast, addErrorToast } = useCustomToast();
  const loadingPageProps = useLoading(false);
  const loaderBeneficiarios = useLoading();
  const qparams = useQueryString();

  const {
    values: valuesLoadingBeneficiarios,
    setLoading: setLoadingBeneficiarios,
    resetLoading: resetLoadingBeneficiarios,
    setSecundario: setSecundarioBeneficiarios,
  } = loaderBeneficiarios;
  const textos = cotizacion?.configuracion?.textos?.paginaCompra;

  const [pageProps, setPageProps1] = useState({
    labelPagar: 'Total a pagar: ',
    pathValuePagar: 'valoresPagar.total',
    hideLabelPagar: false,
    customLabelPagar: null,
    goBack: `/newRegistro/${cotizacion?.idCotizacion}`,
    goToSubmit: `/paginaResumen/${cotizacion?.idCotizacion}`,
    showTitular: true,
    footerButtonContinuar: {
      label: 'Continuar',
      className: 'footer_button__continuar',
      classNameContainer: 'footer_container__continuar',
    },
    loaderBeneficiarios,

    loadingPageProps,
    subheader: {
      titulo: `Ingreso de datos `,
      subtitulo: 'Por favor ingrese la siguiente información.',
    },
    camposBeneficiarios: undefined,
    btnOpciones: [],
    btnOpcionesShow: false,
    fnBtnOpciones: (_props) => {},
    impuestos: [],
    alert: null,
  });

  const setPageProps = (value) => {
    setPageProps1(value);
  };
  const history = useCustomRouter();
  const dispatch = useDispatch();

  const init = async () => {
    const labelBeneficiarioBien =
      cotizacion?.producto?.categoria?.CamposBeneficiariosInfo?.labelBeneficiarioBien ?? '';
    if (labelBeneficiarioBien)
      setPageProps1((prev) => ({
        ...prev,
        subheader: {
          ...prev.subheader,
          titulo: `Ingreso de datos de ${labelBeneficiarioBien}`,
          sutitulo:
            'Por favor ingrese la siguiente información de ' +
            labelBeneficiarioBien +
            ' que quieres agregar.',
        },
      }));
    scrollTop();
    execEvent(
      'initCallback',
      { formMethods: methods, pageProps, setPageProps, setShowForm },
      async () => {
        if (cotizacion.beneficiarios.length > 0) {
          const index = parseInt(qparams?.index ?? 0);
          const beneficiario = cotizacion.beneficiarios[index];
          reset({ ...beneficiario });
          editarBeneficiario(beneficiario, index);
        }
      },
    );
  };

  useEffect(() => {
    guardarLead(idCotizacion, `PAGINA_COMPRA__INGRESO`);
  }, []);

  useEffect(() => {
    if (qparams?.resumen === 'true') {
      return history.push(`/paginaResumen/${idCotizacion}`);
    }
  }, [qparams?.resumen]);

  useEffect(() => {
    if (isLoadingCallbacks) return;
    init();
    return () => {
      editarBeneficiario(null, null);
      execEvent('out');
    };
  }, [isLoadingCallbacks]);

  const desabilitarBoton = () => {
    setDisabledButton(true);
    setTimeout(() => setDisabledButton(false), 2000);
  };

  useEffect(() => {
    if (
      cotizacion &&
      (cotizacion?.producto?.tieneBeneficiario === 0 || cotizacion?.tieneBeneficiario === 0)
    ) {
      onCheckBeneficiarioIgualTitular(true, cotizacion.titular);
    }
  }, [cotizacion]);

  const onSubmit = async (dataform, indexedit = false) => {
    console.log('Inicio ttttttttt ');
    loadingPageProps.setPrincipal('Un momento, estamos preparando tu cotización');
    loadingPageProps.setLoading(true);
    let data: any = {};
    const data2 = {};

    if (pageProps?.camposBeneficiarios) {
      pageProps?.camposBeneficiarios.forEach(({ codCore }) => {
        console.log('PAGINA TITULAR Bene:', codCore);
        data2[codCore] = dataform[codCore];
      });
      dataform = { ...data2 };
    }
    console.log('PAGINA TITULAR Bene:', data2, dataform);

    for (const property in dataform) {
      if (typeof dataform[property] === 'string') data[property] = dataform[property].trim();
      else data[property] = dataform[property];
    }
    guardarLead(idCotizacion, `PAGINA_COMPRA__CLICK_GUARDAR_DATOS`);
    execEvent('onClickGuardarCallback', { data, pageProps, setPageProps }, async (retorno) => {
      setLoadingBeneficiarios(true);
      setSecundarioBeneficiarios('Guardando información...');

      if (indexedit) {
        cotizacion.beneficiarios[0] = { ...cotizacion.beneficiarios[0], ...data };
      } else if (indexEditar !== null) {
        cotizacion.beneficiarios[indexEditar] = { ...cotizacion.beneficiarios[0], ...data };
        editarBeneficiario(null, null);
      } else {
        if (!cotizacion?.beneficiarios) {
          cotizacion.beneficiarios = [];
        }

        const index = cotizacion.beneficiarios.findIndex(
          (item) => item.uniqueKeyV4 === data.uniqueKeyV4,
        );
        if (index !== -1) {
          cotizacion.beneficiarios[index] = data;
        } else {
          cotizacion.beneficiarios.push(data);
        }
      }

      let body = {
        beneficiarios: cotizacion.beneficiarios,
        idCotizacion,
      };
      guardarLead(idCotizacion, 'REGISTRO_BENEFICIARIOS');
      let { data: response } = await Axios.post(urlSetBeneficiarios, JSON.stringify(body));
      if (response.transaccion && response?.cotizacion?.valoresPagar?.transaccion !== false) {
        const callbackProps = { pageProps, setPageProps, responseData: response };

        await execEvent('dispatchCotizacionSetBeneficiarios', callbackProps, () => {
          dispatch(setCotizacion(response.cotizacion));
        });
        console.log('wwww TODO BIEN  ', response);
        resetLoadingBeneficiarios();
        loadingPageProps.setLoading(false);
        methods.reset();
        history.push(pageProps.goToSubmit);
      } else {
        loadingPageProps.setLoading(false);
        resetLoadingBeneficiarios();
        addWarningToast(response?.cotizacion?.valoresPagar?.errorDescripcion);
      }
    });
  };

  const onClickCancelar = () => {
    editarBeneficiario(null, null);
    history.push(`/paginaResumen/${idCotizacion}`);
  };
  const onCheckBeneficiarioIgualTitular = async (isChecked: boolean, data) => {
    if (isChecked) {
      setLoadingBeneficiarios(true);
      setSecundarioBeneficiarios('Guardando información...');
      data.uniqueKeyV4 = uuid.v4();
      const body = {
        beneficiarios: isChecked ? [data] : [],
        beneficiarioIgualTitularChecked: isChecked,
        idCotizacion,
      };
      guardarLead(idCotizacion, 'REGISTRO_BENEFICIARIOS');
      const { data: response } = await Axios.post(urlSetBeneficiarios, JSON.stringify(body));
      if (response.transaccion) {
        dispatch(setCotizacion(response.cotizacion));
      }
      resetLoadingBeneficiarios();
      methods.reset();
      history.push(`/paginaResumen/${idCotizacion}`);
    }
  };

  return (
    <LoadingWrapper {...loadingPageProps.values}>
      <DIV stylePath="paginaCompra.globalStyles" className="container-fluid container-page">
        <NavbarHeader goBack={pageProps?.goBack} />
        <HeaderPage progreso={60} />
        <LoadingWrapper {...valuesLoadingBeneficiarios} height="80%">
          <div className="row justify-content-center">
            <div className="col-md-10 col-lg-7 mt-3">
              <h4 className="titulo font-weight-bold">
                {textos?.titulo ||
                  pageProps?.subheader?.titulo ||
                  (pageProps?.subheader?.titulo ?? '')}
              </h4>
              <p className="descripcion">
                {(textos?.subtitulo ?? '') || (pageProps.subheader.subtitulo ?? '')}
              </p>
            </div>
          </div>
          <EditarVigencia cotizacion={cotizacion} />
          <CheckBeneficiarioIgualTitular
            onCheckBeneficiarioIgualTitular={onCheckBeneficiarioIgualTitular}
          />
          <FormProvider {...methods}>
            {!cotizacion?.beneficiarioIgualTitularChecked && (
              <form
                className="container__form"
                noValidate
                onSubmit={methods.handleSubmit((data) => {
                  desabilitarBoton();
                  onSubmit(data);
                })}
              >
                <div className="row justify-content-center">
                  <div className="col-12 col-md-10 col-lg-8 col-xl-7 mt-3">
                    <strong className="label__bien text-primary">
                      {indexEditar !== null && 'Editar '}{' '}
                      {cotizacion?.producto?.categoria?.CamposBeneficiariosInfo
                        ?.labelBeneficiarioBien ?? ''}
                    </strong>
                    <div className="row justify-content-between">
                      <>
                        <UniqueKeyV4 />
                        <InputsDinamicos
                          inputs={
                            pageProps?.camposBeneficiarios ??
                            (cotizacion?.producto?.categoria?.camposBeneficiarios || [])
                          }
                        />
                      </>
                    </div>
                  </div>
                  {parseInt(cotizacion.beneficiarios.length) !== 0 &&
                    !['6', '7', '9'].includes(cotizacion.flujoPlugin) && (
                      <div className="col-12 text-center">
                        <button
                          type="button"
                          className="form__btn__cancelar btn btn-sm btn-outline-danger"
                          onClick={onClickCancelar}
                        >
                          Cancelar
                        </button>
                      </div>
                    )}
                </div>

                <FooterButton
                  className="footer_button__guardar"
                  classNameContainer="footer_container__guardar"
                  label="Guardar"
                  type="submit"
                  disabled={disabledButton}
                  // onSubmit={methods.handleSubmit((data) => {
                  //   console.log("Click submit");
                  //   onSubmit(data)
                  // })}
                />
              </form>
            )}
            {cotizacion?.beneficiarioIgualTitularChecked && (
              <FooterButton
                className="footer_button__guardar"
                classNameContainer="footer_container__guardar"
                label="Siguiente"
                onClick={() => {
                  editarBeneficiario(null, null);
                }}
              />
            )}

            {pageProps.alert && (
              <div className="row justify-content-center pb-3">
                <div className="col-11 col-md-10 col-lg-7 mt-2">{pageProps.alert}</div>
              </div>
            )}
          </FormProvider>
        </LoadingWrapper>

        {/* {
          ((!showForm && !pageProps.btnOpcionesShow) && (!pageProps.showCertificado || cotizacion?.estadoCliente === 'SS')) && (
            <FooterButton
              label="Continuar"
              onClick={onClickContinuar}
              className="footer_button__continuar"
              classNameContainer="footer_container__continuar"
              disabled={valuesLoadingBeneficiarios.loading || disabledButton}
              {...pageProps.footerButtonContinuar}
            />
          )
        } */}
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(PaginaCompraPage);
